export default {
    /**
     * Datos añadidos a data por el mixin:
     * - matrimonialRegimeOptions: array con tipos de vias
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            matrimonialRegimeOptions: []
        };
    },
    methods: {
        /**
         * Load street types
         */
        loadMatrimonialRegimeOptions() {
            const matrimonialRegime = this.$t("matrimonialRegime", { returnObjects: true });
            this.matrimonialRegimeOptions = Object.entries(matrimonialRegime).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de vías en la variable
     * `this.loadmatrimonialRegimeOptions`
     */
    beforeMount() {
        this.loadMatrimonialRegimeOptions();
    }
};
